import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getIntlCheggProductsServices, getPrimaryNavLinks, getUSCheggProductsServices, getLegalNav } from './navlinks';
var koPrimaryNav = getPrimaryNavLinks(['기업', 'Chegg 소개', 'Chegg 사회적 지원', '단과 대학 마케팅', '투자자 관계', '직업', '제휴 프로그램 참여', '미디어 센터', 'Chegg 네트워크', '고객 서비스', '피드백 보내기', '고객 서비스', '구독 관리', '교육자', '학습 윤리', 'Honor Shield(부정행위 차단)', 'Institute of Digital Learning']);
export var koLegalNav = getLegalNav(['쿠키 고지', '개인정보 보호 설정', '내 정보 판매 금지', '일반 정책', '개인정보 처리방침', '윤리 강령', 'IP 권리']);
var koFooterLegalNote = {
  text: '© 2003-2024 Chegg Inc. All rights reserved.'
};
var koCheggProductServicesIntl = getIntlCheggProductsServices(['Chegg 상품 및 서비스', 'Chegg 학습 도움말', '인용 생성기', '디지털 액세스 코드', '문법 검사기', 'Chegg 수학 해결사', '모바일 앱', '해답 매뉴얼', '표절 검사기', 'Chegg Perks']);
var koCheggProductServicesUS = getUSCheggProductsServices(['Chegg 상품 및 서비스', '저렴한 교과서', 'Chegg 학습 도움말', '인용 생성기', '단과 대학 교과서', '디지털 액세스 코드', '전자 교과서', '문법 검사기', 'Chegg 수학 해결사', '모바일 앱', '해답 매뉴얼', '표절 검사기', '교과서 대여', '중고 교과서', 'Chegg Perks']);
export var koreanContentIntl = {
  PrimaryNav: [koCheggProductServicesIntl].concat(_toConsumableArray(koPrimaryNav)),
  LegalNav: koLegalNav,
  FooterLegalNote: koFooterLegalNote
};
export var koreanContentUS = {
  PrimaryNav: [koCheggProductServicesUS].concat(_toConsumableArray(koPrimaryNav)),
  LegalNav: koLegalNav,
  FooterLegalNote: koFooterLegalNote
};